function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var pickr_min = createCommonjsModule(function (module, exports) {
  /*! Pickr 1.2.7 MIT | https://github.com/Simonwep/pickr */
  !function (t, e) {
     module.exports = e() ;
  }(window, function () {
    return function (t) {
      var e = {};

      function o(n) {
        if (e[n]) return e[n].exports;
        var i = e[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return t[n].call(i.exports, i, i.exports, o), i.l = !0, i.exports;
      }

      return o.m = t, o.c = e, o.d = function (t, e, n) {
        o.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: n
        });
      }, o.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, o.t = function (t, e) {
        if (1 & e && (t = o(t)), 8 & e) return t;
        if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
        var n = Object.create(null);
        if (o.r(n), Object.defineProperty(n, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var i in t) {
          o.d(n, i, function (e) {
            return t[e];
          }.bind(null, i));
        }
        return n;
      }, o.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t["default"];
        } : function () {
          return t;
        };
        return o.d(e, "a", e), e;
      }, o.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, o.p = "", o(o.s = 0);
    }([function (t, e, o) {

      o.r(e);
      var n = {};

      function i(t, e) {
        var o = Object.keys(t);
        return Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t)), e && (o = o.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), o;
      }

      function r(t) {
        for (var e = 1; e < arguments.length; e++) {
          var o = null != arguments[e] ? arguments[e] : {};
          e % 2 ? i(o, !0).forEach(function (e) {
            s(t, e, o[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(o)) : i(o).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(o, e));
          });
        }

        return t;
      }

      function s(t, e, o) {
        return e in t ? Object.defineProperty(t, e, {
          value: o,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = o, t;
      }

      o.r(n), o.d(n, "on", function () {
        return c;
      }), o.d(n, "off", function () {
        return a;
      }), o.d(n, "createElementFromString", function () {
        return p;
      }), o.d(n, "removeAttribute", function () {
        return u;
      }), o.d(n, "createFromTemplate", function () {
        return h;
      }), o.d(n, "eventPath", function () {
        return d;
      }), o.d(n, "adjustableInputNumbers", function () {
        return f;
      });
      var c = l.bind(null, "addEventListener"),
          a = l.bind(null, "removeEventListener");

      function l(t, e, o, n) {
        var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
        e instanceof HTMLCollection || e instanceof NodeList ? e = Array.from(e) : Array.isArray(e) || (e = [e]), Array.isArray(o) || (o = [o]);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _s = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = o[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _e = _step2.value;

                _s[t](_e, n, r({
                  capture: !1
                }, i));
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                  _iterator2["return"]();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return Array.prototype.slice.call(arguments, 1);
      }

      function p(t) {
        var e = document.createElement("div");
        return e.innerHTML = t.trim(), e.firstElementChild;
      }

      function u(t, e) {
        var o = t.getAttribute(e);
        return t.removeAttribute(e), o;
      }

      function h(t) {
        return function t(e) {
          var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = u(e, ":obj"),
              i = u(e, ":ref"),
              r = n ? o[n] = {} : o;
          i && (o[i] = e);

          for (var _i = 0, _Array$from = Array.from(e.children); _i < _Array$from.length; _i++) {
            var _o = _Array$from[_i];

            var _e2 = u(_o, ":arr"),
                _n = t(_o, _e2 ? {} : r);

            _e2 && (r[_e2] || (r[_e2] = [])).push(Object.keys(_n).length ? _n : _o);
          }

          return o;
        }(p(t));
      }

      function d(t) {
        var e = t.path || t.composedPath && t.composedPath();
        if (e) return e;
        var o = t.target.parentElement;

        for (e = [t.target, o]; o = o.parentElement;) {
          e.push(o);
        }

        return e.push(document, window), e;
      }

      function f(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (t) {
          return t;
        };

        function o(o) {
          var n = [.001, .01, .1][Number(o.shiftKey || 2 * o.ctrlKey)] * (o.deltaY < 0 ? 1 : -1);
          var i = 0,
              r = t.selectionStart;
          t.value = t.value.replace(/[\d.]+/g, function (t, o) {
            return o <= r && o + t.length >= r ? (r = o, e(Number(t), n, i)) : (i++, t);
          }), t.focus(), t.setSelectionRange(r, r), o.preventDefault(), t.dispatchEvent(new Event("input"));
        }

        c(t, "focus", function () {
          return c(window, "wheel", o, {
            passive: !1
          });
        }), c(t, "blur", function () {
          return a(window, "wheel", o);
        });
      }

      var m = Math.min,
          v = Math.max,
          b = Math.floor,
          y = Math.round;

      function g(t, e, o) {
        e /= 100, o /= 100;
        var n = b(t = t / 360 * 6),
            i = t - n,
            r = o * (1 - e),
            s = o * (1 - i * e),
            c = o * (1 - (1 - i) * e),
            a = n % 6;
        return [255 * [o, s, r, r, c, o][a], 255 * [c, o, o, s, r, r][a], 255 * [r, r, c, o, o, s][a]];
      }

      function _(t, e, o) {
        var n = (2 - (e /= 100)) * (o /= 100) / 2;
        return 0 !== n && (e = 1 === n ? 0 : n < .5 ? e * o / (2 * n) : e * o / (2 - 2 * n)), [t, 100 * e, 100 * n];
      }

      function w(t, e, o) {
        var n, i, r;
        var s = m(t /= 255, e /= 255, o /= 255),
            c = v(t, e, o),
            a = c - s;
        if (0 === a) n = i = 0;else {
          i = a / c;

          var _r = ((c - t) / 6 + a / 2) / a,
              _s2 = ((c - e) / 6 + a / 2) / a,
              _l = ((c - o) / 6 + a / 2) / a;

          t === c ? n = _l - _s2 : e === c ? n = 1 / 3 + _r - _l : o === c && (n = 2 / 3 + _s2 - _r), n < 0 ? n += 1 : n > 1 && (n -= 1);
        }
        return [360 * n, 100 * i, 100 * (r = c)];
      }

      function C(t, e, o, n) {
        return e /= 100, o /= 100, _toConsumableArray(w(255 * (1 - m(1, (t /= 100) * (1 - (n /= 100)) + n)), 255 * (1 - m(1, e * (1 - n) + n)), 255 * (1 - m(1, o * (1 - n) + n))));
      }

      function A(t, e, o) {
        return e /= 100, [t, 2 * (e *= (o /= 100) < .5 ? o : 1 - o) / (o + e) * 100, 100 * (o + e)];
      }

      function k(t) {
        return w.apply(void 0, _toConsumableArray(t.match(/.{2}/g).map(function (t) {
          return parseInt(t, 16);
        })));
      }

      function O(t) {
        t = t.match(/^[a-zA-Z]+$/) ? function (t) {
          if ("black" === t.toLowerCase()) return "#000000";
          var e = document.createElement("canvas").getContext("2d");
          return e.fillStyle = t, "#000000" === e.fillStyle ? null : e.fillStyle;
        }(t) : t;

        var e = {
          cmyk: /^cmyk[\D]+([\d.]+)[\D]+([\d.]+)[\D]+([\d.]+)[\D]+([\d.]+)/i,
          rgba: /^((rgba)|rgb)[\D]+([\d.]+)[\D]+([\d.]+)[\D]+([\d.]+)[\D]*?([\d.]+|$)/i,
          hsla: /^((hsla)|hsl)[\D]+([\d.]+)[\D]+([\d.]+)[\D]+([\d.]+)[\D]*?([\d.]+|$)/i,
          hsva: /^((hsva)|hsv)[\D]+([\d.]+)[\D]+([\d.]+)[\D]+([\d.]+)[\D]*?([\d.]+|$)/i,
          hexa: /^#?(([\dA-Fa-f]{3,4})|([\dA-Fa-f]{6})|([\dA-Fa-f]{8}))$/i
        },
            o = function o(t) {
          return t.map(function (t) {
            return /^(|\d+)\.\d+|\d+$/.test(t) ? Number(t) : void 0;
          });
        };

        var n;

        t: for (var _i2 in e) {
          if (!(n = e[_i2].exec(t))) continue;

          var _r2 = !!n[2];

          switch (_i2) {
            case "cmyk":
              {
                var _o2 = o(n),
                    _o3 = _slicedToArray(_o2, 5),
                    _t = _o3[1],
                    _e3 = _o3[2],
                    _r3 = _o3[3],
                    _s3 = _o3[4];

                if (_t > 100 || _e3 > 100 || _r3 > 100 || _s3 > 100) break t;
                return {
                  values: C(_t, _e3, _r3, _s3),
                  type: _i2
                };
              }

            case "rgba":
              {
                var _o4 = o(n),
                    _o5 = _slicedToArray(_o4, 7),
                    _t2 = _o5[3],
                    _e4 = _o5[4],
                    _s4 = _o5[5],
                    _c = _o5[6];

                if (_t2 > 255 || _e4 > 255 || _s4 > 255 || _c < 0 || _c > 1 || _r2 === !_c) break t;
                return {
                  values: [].concat(_toConsumableArray(w(_t2, _e4, _s4)), [_c]),
                  a: _c,
                  type: _i2
                };
              }

            case "hexa":
              {
                var _n2 = n,
                    _n3 = _slicedToArray(_n2, 2),
                    _t3 = _n3[1];

                4 !== _t3.length && 3 !== _t3.length || (_t3 = _t3.split("").map(function (t) {
                  return t + t;
                }).join(""));

                var _e5 = _t3.substring(0, 6);

                var _o6 = _t3.substring(6);

                return _o6 = _o6 ? parseInt(_o6, 16) / 255 : void 0, {
                  values: [].concat(_toConsumableArray(k(_e5)), [_o6]),
                  a: _o6,
                  type: _i2
                };
              }

            case "hsla":
              {
                var _o7 = o(n),
                    _o8 = _slicedToArray(_o7, 7),
                    _t4 = _o8[3],
                    _e6 = _o8[4],
                    _s5 = _o8[5],
                    _c2 = _o8[6];

                if (_t4 > 360 || _e6 > 100 || _s5 > 100 || _c2 < 0 || _c2 > 1 || _r2 === !_c2) break t;
                return {
                  values: [].concat(_toConsumableArray(A(_t4, _e6, _s5)), [_c2]),
                  a: _c2,
                  type: _i2
                };
              }

            case "hsva":
              {
                var _o9 = o(n),
                    _o10 = _slicedToArray(_o9, 7),
                    _t5 = _o10[3],
                    _e7 = _o10[4],
                    _s6 = _o10[5],
                    _c3 = _o10[6];

                if (_t5 > 360 || _e7 > 100 || _s6 > 100 || _c3 < 0 || _c3 > 1 || _r2 === !_c3) break t;
                return {
                  values: [_t5, _e7, _s6, _c3],
                  a: _c3,
                  type: _i2
                };
              }
          }
        }

        return {
          values: null,
          type: null
        };
      }

      function S() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

        var i = function i(t, e) {
          return function () {
            var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
            return e(~o ? t.map(function (t) {
              return Number(t.toFixed(o));
            }) : t);
          };
        },
            r = {
          h: t,
          s: e,
          v: o,
          a: n,
          toHSVA: function toHSVA() {
            var t = [r.h, r.s, r.v, r.a];
            return t.toString = i(t, function (t) {
              return "hsva(".concat(t[0], ", ").concat(t[1], "%, ").concat(t[2], "%, ").concat(r.a, ")");
            }), t;
          },
          toHSLA: function toHSLA() {
            var t = [].concat(_toConsumableArray(_(r.h, r.s, r.v)), [r.a]);
            return t.toString = i(t, function (t) {
              return "hsla(".concat(t[0], ", ").concat(t[1], "%, ").concat(t[2], "%, ").concat(r.a, ")");
            }), t;
          },
          toRGBA: function toRGBA() {
            var t = [].concat(_toConsumableArray(g(r.h, r.s, r.v)), [r.a]);
            return t.toString = i(t, function (t) {
              return "rgba(".concat(t[0], ", ").concat(t[1], ", ").concat(t[2], ", ").concat(r.a, ")");
            }), t;
          },
          toCMYK: function toCMYK() {
            var t = function (t, e, o) {
              var n = g(t, e, o),
                  i = n[0] / 255,
                  r = n[1] / 255,
                  s = n[2] / 255;
              var c, a, l, p;
              return [100 * (a = 1 === (c = m(1 - i, 1 - r, 1 - s)) ? 0 : (1 - i - c) / (1 - c)), 100 * (l = 1 === c ? 0 : (1 - r - c) / (1 - c)), 100 * (p = 1 === c ? 0 : (1 - s - c) / (1 - c)), 100 * c];
            }(r.h, r.s, r.v);

            return t.toString = i(t, function (t) {
              return "cmyk(".concat(t[0], "%, ").concat(t[1], "%, ").concat(t[2], "%, ").concat(t[3], "%)");
            }), t;
          },
          toHEXA: function toHEXA() {
            var t = function (t, e, o) {
              return g(t, e, o).map(function (t) {
                return y(t).toString(16).padStart(2, "0");
              });
            }(r.h, r.s, r.v),
                e = r.a >= 1 ? "" : Number((255 * r.a).toFixed(0)).toString(16).toUpperCase().padStart(2, "0");

            return e && t.push(e), t.toString = function () {
              return "#".concat(t.join("").toUpperCase());
            }, t;
          },
          clone: function clone() {
            return S(r.h, r.s, r.v, r.a);
          }
        };

        return r;
      }

      var j = function j(t) {
        return Math.max(Math.min(t, 1), 0);
      };

      function P(t) {
        var e = {
          options: Object.assign({
            lock: null,
            onchange: function onchange() {
              return 0;
            },
            onstop: function onstop() {
              return 0;
            }
          }, t),
          _tapstart: function _tapstart(t) {
            c(document, ["mouseup", "touchend", "touchcancel"], e._tapstop), c(document, ["mousemove", "touchmove"], e._tapmove), t.preventDefault(), e._tapmove(t);
          },
          _tapmove: function _tapmove(t) {
            var n = e.options.lock,
                i = e.cache,
                r = o.element,
                s = o.wrapper,
                c = s.getBoundingClientRect();
            var a = 0,
                l = 0;

            if (t) {
              var _e8 = t && t.touches && t.touches[0];

              a = t ? (_e8 || t).clientX : 0, l = t ? (_e8 || t).clientY : 0, a < c.left ? a = c.left : a > c.left + c.width && (a = c.left + c.width), l < c.top ? l = c.top : l > c.top + c.height && (l = c.top + c.height), a -= c.left, l -= c.top;
            } else i && (a = i.x * c.width, l = i.y * c.height);

            "h" !== n && (r.style.left = "calc(".concat(a / c.width * 100, "% - ").concat(r.offsetWidth / 2, "px)")), "v" !== n && (r.style.top = "calc(".concat(l / c.height * 100, "% - ").concat(r.offsetHeight / 2, "px)")), e.cache = {
              x: a / c.width,
              y: l / c.height
            };
            var p = j(a / s.offsetWidth),
                u = j(l / s.offsetHeight);

            switch (n) {
              case "v":
                return o.onchange(p);

              case "h":
                return o.onchange(u);

              default:
                return o.onchange(p, u);
            }
          },
          _tapstop: function _tapstop() {
            e.options.onstop(), a(document, ["mouseup", "touchend", "touchcancel"], e._tapstop), a(document, ["mousemove", "touchmove"], e._tapmove);
          },
          trigger: function trigger() {
            e._tapmove();
          },
          update: function update() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var _e$options$wrapper$ge = e.options.wrapper.getBoundingClientRect(),
                n = _e$options$wrapper$ge.left,
                i = _e$options$wrapper$ge.top,
                r = _e$options$wrapper$ge.width,
                s = _e$options$wrapper$ge.height;

            "h" === e.options.lock && (o = t), e._tapmove({
              clientX: n + r * t,
              clientY: i + s * o
            });
          },
          destroy: function destroy() {
            var t = e.options,
                o = e._tapstart;
            a([t.wrapper, t.element], "mousedown", o), a([t.wrapper, t.element], "touchstart", o, {
              passive: !1
            });
          }
        },
            o = e.options,
            n = e._tapstart;
        return c([o.wrapper, o.element], "mousedown", n), c([o.wrapper, o.element], "touchstart", n, {
          passive: !1
        }), e;
      }

      function L() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        t = Object.assign({
          onchange: function onchange() {
            return 0;
          },
          className: "",
          elements: []
        }, t);
        var e = c(t.elements, "click", function (e) {
          t.elements.forEach(function (o) {
            return o.classList[e.target === o ? "add" : "remove"](t.className);
          }), t.onchange(e);
        });
        return {
          destroy: function destroy() {
            return a.apply(void 0, _toConsumableArray(e));
          }
        };
      }

      function x(_ref) {
        var t = _ref.el,
            e = _ref.reference,
            _ref$padding = _ref.padding,
            o = _ref$padding === void 0 ? 8 : _ref$padding;

        var n = {
          start: "sme",
          middle: "mse",
          end: "ems"
        },
            i = {
          top: "tbrl",
          right: "rltb",
          bottom: "btrl",
          left: "lrbt"
        },
            r = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return function (e) {
            var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t[e];
            if (o) return o;

            var _e$split = e.split("-"),
                _e$split2 = _slicedToArray(_e$split, 2),
                n = _e$split2[0],
                _e$split2$ = _e$split2[1],
                i = _e$split2$ === void 0 ? "middle" : _e$split2$,
                r = "top" === n || "bottom" === n;

            return t[e] = {
              position: n,
              variant: i,
              isVertical: r
            };
          };
        }();

        return {
          update: function update(s) {
            var _r4 = r(s),
                c = _r4.position,
                a = _r4.variant,
                l = _r4.isVertical,
                p = e.getBoundingClientRect(),
                u = t.getBoundingClientRect(),
                h = function h(t) {
              return t ? {
                t: p.top - u.height - o,
                b: p.bottom + o
              } : {
                r: p.right + o,
                l: p.left - u.width - o
              };
            },
                d = function d(t) {
              return t ? {
                s: p.left + p.width - u.width,
                m: -u.width / 2 + (p.left + p.width / 2),
                e: p.left
              } : {
                s: p.bottom - u.height,
                m: p.bottom - p.height / 2 - u.height / 2,
                e: p.bottom - p.height
              };
            },
                f = {};

            function m(e, o, n) {
              var i = "top" === n,
                  r = i ? u.height : u.width,
                  s = window[i ? "innerHeight" : "innerWidth"];
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = e[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var _i3 = _step3.value;

                  var _e9 = o[_i3],
                      _c4 = f[n] = "".concat(_e9, "px");

                  if (_e9 > 0 && _e9 + r < s) return t.style[n] = _c4, !0;
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                    _iterator3["return"]();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }

              return !1;
            }

            for (var _i4 = 0, _arr = [l, !l]; _i4 < _arr.length; _i4++) {
              var _t6 = _arr[_i4];

              var _e10 = m(i[c], h(_t6), _t6 ? "top" : "left"),
                  _o11 = m(n[a], d(_t6), _t6 ? "left" : "top");

              if (_e10 && _o11) return;
            }

            t.style.left = f.left, t.style.top = f.top;
          }
        };
      }

      var E = function E(_ref2) {
        var t = _ref2.components,
            e = _ref2.strings,
            o = _ref2.useAsButton,
            n = _ref2.inline,
            i = _ref2.appClass,
            r = _ref2.theme,
            s = _ref2.lockOpacity;

        var c = function c(t) {
          return t ? "" : 'style="display:none" hidden';
        },
            a = h('\n      <div :ref="root" class="pickr">\n\n        '.concat(o ? "" : '<button type="button" :ref="button" class="pcr-button"></button>', '\n\n        <div :ref="app" class="pcr-app ').concat(i || "", '" data-theme="').concat(r, '" ').concat(n ? 'style="position: unset"' : "", '>\n          <div class="pcr-selection" ').concat(c(t.palette), '>\n            <div :obj="preview" class="pcr-color-preview" ').concat(c(t.preview), '>\n              <button type="button" :ref="lastColor" class="pcr-last-color"></button>\n              <div :ref="currentColor" class="pcr-current-color"></div>\n            </div>\n\n            <div :obj="palette" class="pcr-color-palette">\n              <div :ref="picker" class="pcr-picker"></div>\n              <div :ref="palette" class="pcr-palette"></div>\n            </div>\n\n            <div :obj="hue" class="pcr-color-chooser" ').concat(c(t.hue), '>\n              <div :ref="picker" class="pcr-picker"></div>\n              <div :ref="slider" class="pcr-hue pcr-slider"></div>\n            </div>\n\n            <div :obj="opacity" class="pcr-color-opacity" ').concat(c(t.opacity), '>\n              <div :ref="picker" class="pcr-picker"></div>\n              <div :ref="slider" class="pcr-opacity pcr-slider"></div>\n            </div>\n          </div>\n\n          <div class="pcr-swatches ').concat(t.palette ? "" : " pcr-last", '" :ref="swatches"></div> \n\n          <div :obj="interaction" class="pcr-interaction" ').concat(c(Object.keys(t.interaction).length), '>\n            <input :ref="result" class="pcr-result" type="text" spellcheck="false" ').concat(c(t.interaction.input), '>\n\n            <input :arr="options" class="pcr-type" data-type="HEXA" value="').concat(s ? "HEX" : "HEXA", '" type="button" ').concat(c(t.interaction.hex), '>\n            <input :arr="options" class="pcr-type" data-type="RGBA" value="').concat(s ? "RGB" : "RGBA", '" type="button" ').concat(c(t.interaction.rgba), '>\n            <input :arr="options" class="pcr-type" data-type="HSLA" value="').concat(s ? "HSL" : "HSLA", '" type="button" ').concat(c(t.interaction.hsla), '>\n            <input :arr="options" class="pcr-type" data-type="HSVA" value="').concat(s ? "HSV" : "HSVA", '" type="button" ').concat(c(t.interaction.hsva), '>\n            <input :arr="options" class="pcr-type" data-type="CMYK" value="CMYK" type="button" ').concat(c(t.interaction.cmyk), '>\n\n            <input :ref="save" class="pcr-save" value="').concat(e.save || "Save", '" type="button" ').concat(c(t.interaction.save), '>\n            <input :ref="cancel" class="pcr-clear" value="').concat(e.cancel || "Cancel", '" type="button" ').concat(c(t.interaction.cancel), '>\n            <input :ref="clear" class="pcr-clear" value="').concat(e.clear || "Clear", '" type="button" ').concat(c(t.interaction.clear), ">\n          </div>\n        </div>\n      </div>\n    ")),
            l = a.interaction;

        return l.options.find(function (t) {
          return !t.hidden && !t.classList.add("active");
        }), l.type = function () {
          return l.options.find(function (t) {
            return t.classList.contains("active");
          });
        }, a;
      };

      function B(t, e, o) {
        return e in t ? Object.defineProperty(t, e, {
          value: o,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = o, t;
      }

      var R =
      /*#__PURE__*/
      function () {
        function R(t) {
          var _this = this;

          _classCallCheck(this, R);

          B(this, "_initializingActive", !0), B(this, "_recalc", !0), B(this, "_color", S()), B(this, "_lastColor", S()), B(this, "_swatchColors", []), B(this, "_eventListener", {
            init: [],
            save: [],
            hide: [],
            show: [],
            clear: [],
            change: [],
            changestop: [],
            cancel: [],
            swatchselect: []
          }), this.options = t = Object.assign({
            appClass: null,
            theme: "classic",
            useAsButton: !1,
            disabled: !1,
            comparison: !0,
            closeOnScroll: !1,
            outputPrecision: 0,
            lockOpacity: !1,
            autoReposition: !0,
            components: {
              interaction: {}
            },
            strings: {},
            swatches: null,
            inline: !1,
            sliders: null,
            "default": "#42445a",
            defaultRepresentation: null,
            position: "bottom-middle",
            adjustableNumbers: !0,
            showAlways: !1,
            closeWithKey: "Escape"
          }, t);
          var _t7 = t,
              e = _t7.swatches,
              o = _t7.inline,
              n = _t7.components,
              i = _t7.theme,
              r = _t7.sliders,
              s = _t7.lockOpacity;
          ["nano", "monolith"].includes(i) && !r && (t.sliders = "h"), n.interaction || (n.interaction = {});
          var c = n.preview,
              a = n.opacity,
              l = n.hue,
              p = n.palette;
          n.opacity = !s && a, n.palette = p || c || a || l, o && (t.showAlways = !0), this._preBuild(), this._buildComponents(), this._bindEvents(), this._finalBuild(), e && e.length && e.forEach(function (t) {
            return _this.addSwatch(t);
          }), this._nanopop = x({
            reference: this._root.button,
            el: this._root.app
          });
          var u = this._root.app,
              h = this;
          requestAnimationFrame(function e() {
            if (!u.offsetWidth && u.parentElement !== document.body) return requestAnimationFrame(e);
            h.setColor(t["default"]), h._rePositioningPicker(), t.defaultRepresentation && (h._representation = t.defaultRepresentation, h.setColorRepresentation(h._representation)), t.showAlways && h.show(), h._initializingActive = !1, h._emit("init");
          });
        }

        _createClass(R, [{
          key: "_preBuild",
          value: function _preBuild() {
            var t = this.options;
            "string" == typeof t.el && (t.el = t.el.split(/>>/g).reduce(function (t, e, o, n) {
              return t = t.querySelector(e), o < n.length - 1 ? t.shadowRoot : t;
            }, document)), this._root = E(t), t.useAsButton && (this._root.button = t.el), document.body.appendChild(this._root.root);
          }
        }, {
          key: "_finalBuild",
          value: function _finalBuild() {
            var t = this.options,
                e = this._root;

            if (document.body.removeChild(e.root), t.inline) {
              var _o12 = t.el.parentElement;
              t.el.nextSibling ? _o12.insertBefore(e.app, t.el.nextSibling) : _o12.appendChild(e.app);
            } else document.body.appendChild(e.app);

            t.useAsButton ? t.inline && t.el.remove() : t.el.parentNode.replaceChild(e.root, t.el), t.disabled && this.disable(), t.comparison || (e.button.style.transition = "none", t.useAsButton || (e.preview.lastColor.style.transition = "none")), this.hide();
          }
        }, {
          key: "_buildComponents",
          value: function _buildComponents() {
            var t = this,
                e = this.options.components,
                o = (t.options.sliders || "v").repeat(2),
                _ref3 = o.match(/^[vh]+$/g) ? o : [],
                _ref4 = _slicedToArray(_ref3, 2),
                n = _ref4[0],
                i = _ref4[1],
                r = {
              palette: P({
                element: t._root.palette.picker,
                wrapper: t._root.palette.palette,
                onstop: function onstop() {
                  return t._emit("changestop", t);
                },
                onchange: function onchange(o, n) {
                  if (!e.palette) return;
                  var i = t._color,
                      r = t._root,
                      s = t.options;
                  t._recalc && (i.s = 100 * o, i.v = 100 - 100 * n, i.v < 0 && (i.v = 0), t._updateOutput());
                  var c = i.toRGBA().toString(0);
                  this.element.style.background = c, this.wrapper.style.background = "\n                        linear-gradient(to top, rgba(0, 0, 0, ".concat(i.a, "), transparent),\n                        linear-gradient(to left, hsla(").concat(i.h, ", 100%, 50%, ").concat(i.a, "), rgba(255, 255, 255, ").concat(i.a, "))\n                    "), s.comparison || (r.button.style.color = c, s.useAsButton || (r.preview.lastColor.style.color = c)), r.preview.currentColor.style.color = c, t.options.comparison || r.button.classList.remove("clear");
                }
              }),
              hue: P({
                lock: "v" === i ? "h" : "v",
                element: t._root.hue.picker,
                wrapper: t._root.hue.slider,
                onstop: function onstop() {
                  return t._emit("changestop", t);
                },
                onchange: function onchange(o) {
                  e.hue && e.palette && (t._recalc && (t._color.h = 360 * o), this.element.style.backgroundColor = "hsl(".concat(t._color.h, ", 100%, 50%)"), r.palette.trigger());
                }
              }),
              opacity: P({
                lock: "v" === n ? "h" : "v",
                element: t._root.opacity.picker,
                wrapper: t._root.opacity.slider,
                onstop: function onstop() {
                  return t._emit("changestop", t);
                },
                onchange: function onchange(o) {
                  e.opacity && e.palette && (t._recalc && (t._color.a = Math.round(100 * o) / 100), this.element.style.background = "rgba(0, 0, 0, ".concat(t._color.a, ")"), r.palette.trigger());
                }
              }),
              selectable: L({
                elements: t._root.interaction.options,
                className: "active",
                onchange: function onchange(e) {
                  t._representation = e.target.getAttribute("data-type").toUpperCase(), t._recalc && t._updateOutput();
                }
              })
            };

            this._components = r;
          }
        }, {
          key: "_bindEvents",
          value: function _bindEvents() {
            var _this2 = this;

            var t = this._root,
                e = this.options,
                o = [c(t.interaction.clear, "click", function () {
              return _this2._clearColor();
            }), c([t.interaction.cancel, t.preview.lastColor], "click", function () {
              _this2._emit("cancel", _this2), _this2.setHSVA.apply(_this2, _toConsumableArray(_this2._lastColor.toHSVA()).concat([!0]));
            }), c(t.interaction.save, "click", function () {
              !_this2.applyColor() && !e.showAlways && _this2.hide();
            }), c(t.interaction.result, ["keyup", "input"], function (t) {
              _this2.setColor(t.target.value, !0) && !_this2._initializingActive && _this2._emit("change", _this2._color), t.stopImmediatePropagation();
            }), c(t.interaction.result, ["focus", "blur"], function (t) {
              _this2._recalc = "blur" === t.type, _this2._recalc && _this2._updateOutput();
            }), c([t.palette.palette, t.palette.picker, t.hue.slider, t.hue.picker, t.opacity.slider, t.opacity.picker], ["mousedown", "touchstart"], function () {
              return _this2._recalc = !0;
            })];

            if (!e.showAlways) {
              var _n4 = e.closeWithKey;
              o.push(c(t.button, "click", function () {
                return _this2.isOpen() ? _this2.hide() : _this2.show();
              }), c(document, "keyup", function (t) {
                return _this2.isOpen() && (t.key === _n4 || t.code === _n4) && _this2.hide();
              }), c(document, ["touchstart", "mousedown"], function (e) {
                _this2.isOpen() && !d(e).some(function (e) {
                  return e === t.app || e === t.button;
                }) && _this2.hide();
              }, {
                capture: !0
              }));
            }

            if (e.adjustableNumbers) {
              var _e11 = {
                rgba: [255, 255, 255, 1],
                hsva: [360, 100, 100, 1],
                hsla: [360, 100, 100, 1],
                cmyk: [100, 100, 100, 100]
              };
              f(t.interaction.result, function (t, o, n) {
                var i = _e11[_this2.getColorRepresentation().toLowerCase()];

                if (i) {
                  var _e12 = i[n],
                      _r5 = t + (_e12 >= 100 ? 1e3 * o : o);

                  return _r5 <= 0 ? 0 : Number((_r5 < _e12 ? _r5 : _e12).toPrecision(3));
                }

                return t;
              });
            }

            if (e.autoReposition && !e.inline) {
              var _t8 = null;

              var _n5 = this;

              o.push(c(window, ["scroll", "resize"], function () {
                _n5.isOpen() && (e.closeOnScroll && _n5.hide(), null === _t8 ? (_t8 = setTimeout(function () {
                  return _t8 = null;
                }, 100), requestAnimationFrame(function e() {
                  _n5._rePositioningPicker(), null !== _t8 && requestAnimationFrame(e);
                })) : (clearTimeout(_t8), _t8 = setTimeout(function () {
                  return _t8 = null;
                }, 100)));
              }, {
                capture: !0
              }));
            }

            this._eventBindings = o;
          }
        }, {
          key: "_rePositioningPicker",
          value: function _rePositioningPicker() {
            var t = this.options;

            if (!t.inline) {
              var _e13 = this._root.app;
              matchMedia("(max-width: 576px)").matches ? Object.assign(_e13.style, {
                margin: "auto",
                height: "".concat(_e13.getBoundingClientRect().height, "px"),
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
              }) : (Object.assign(_e13.style, {
                margin: null,
                right: null,
                top: null,
                bottom: null,
                left: null,
                height: null
              }), this._nanopop.update(t.position));
            }
          }
        }, {
          key: "_updateOutput",
          value: function _updateOutput() {
            var t = this._root,
                e = this._color,
                o = this.options;

            if (t.interaction.type()) {
              var _n6 = "to".concat(t.interaction.type().getAttribute("data-type"));

              t.interaction.result.value = "function" == typeof e[_n6] ? e[_n6]().toString(o.outputPrecision) : "";
            }

            !this._initializingActive && this._recalc && this._emit("change", e);
          }
        }, {
          key: "_clearColor",
          value: function _clearColor() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            var e = this._root,
                o = this.options;
            o.useAsButton || (e.button.style.color = "rgba(0, 0, 0, 0.15)"), e.button.classList.add("clear"), o.showAlways || this.hide(), this._initializingActive || t || (this._emit("save", null), this._emit("clear", this));
          }
        }, {
          key: "_parseLocalColor",
          value: function _parseLocalColor(t) {
            var _O = O(t),
                e = _O.values,
                o = _O.type,
                n = _O.a,
                i = this.options.lockOpacity,
                r = void 0 !== n && 1 !== n;

            return e && 3 === e.length && (e[3] = void 0), {
              values: !e || i && r ? null : e,
              type: o
            };
          }
        }, {
          key: "_emit",
          value: function _emit(t) {
            var _this3 = this;

            for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              e[_key - 1] = arguments[_key];
            }

            this._eventListener[t].forEach(function (t) {
              return t.apply(void 0, e.concat([_this3]));
            });
          }
        }, {
          key: "on",
          value: function on(t, e) {
            return "function" == typeof e && "string" == typeof t && t in this._eventListener && this._eventListener[t].push(e), this;
          }
        }, {
          key: "off",
          value: function off(t, e) {
            var o = this._eventListener[t];

            if (o) {
              var _t9 = o.indexOf(e);

              ~_t9 && o.splice(_t9, 1);
            }

            return this;
          }
        }, {
          key: "addSwatch",
          value: function addSwatch(t) {
            var _this4 = this;

            var _this$_parseLocalColo = this._parseLocalColor(t),
                e = _this$_parseLocalColo.values;

            if (e) {
              var _t10 = this._swatchColors,
                  _o13 = this._root,
                  _n7 = S.apply(void 0, _toConsumableArray(e)),
                  _i5 = p('<button type="button" style="color: '.concat(_n7.toRGBA().toString(0), '"/>'));

              return _o13.swatches.appendChild(_i5), _t10.push({
                element: _i5,
                hsvaColorObject: _n7
              }), this._eventBindings.push(c(_i5, "click", function () {
                _this4.setHSVA.apply(_this4, _toConsumableArray(_n7.toHSVA()).concat([!0])), _this4._emit("swatchselect", _n7), _this4._emit("change", _n7);
              })), !0;
            }

            return !1;
          }
        }, {
          key: "removeSwatch",
          value: function removeSwatch(t) {
            var e = this._swatchColors[t];

            if (e) {
              var _o14 = e.element;
              return this._root.swatches.removeChild(_o14), this._swatchColors.splice(t, 1), !0;
            }

            return !1;
          }
        }, {
          key: "applyColor",
          value: function applyColor() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;

            var _this$_root = this._root,
                e = _this$_root.preview,
                o = _this$_root.button,
                n = this._color.toRGBA().toString();

            e.lastColor.style.color = n, this.options.useAsButton || (o.style.color = n), o.classList.remove("clear"), this._lastColor = this._color.clone(), this._initializingActive || t || this._emit("save", this._color);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var _this5 = this;

            this._eventBindings.forEach(function (t) {
              return a.apply(void 0, _toConsumableArray(t));
            }), Object.keys(this._components).forEach(function (t) {
              return _this5._components[t].destroy();
            });
          }
        }, {
          key: "destroyAndRemove",
          value: function destroyAndRemove() {
            var _this6 = this;

            this.destroy();
            var _this$_root2 = this._root,
                t = _this$_root2.root,
                e = _this$_root2.app;
            t.parentElement && t.parentElement.removeChild(t), e.parentElement.removeChild(e), Object.keys(this).forEach(function (t) {
              return _this6[t] = null;
            });
          }
        }, {
          key: "hide",
          value: function hide() {
            return this.options.inline || (this._root.app.classList.remove("visible"), this._emit("hide", this)), this;
          }
        }, {
          key: "show",
          value: function show() {
            return this.options.disabled || (this._root.app.classList.add("visible"), this._rePositioningPicker(), this._emit("show", this)), this;
          }
        }, {
          key: "isOpen",
          value: function isOpen() {
            return this._root.app.classList.contains("visible");
          }
        }, {
          key: "setHSVA",
          value: function setHSVA() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 360;
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
            var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;
            var r = this._recalc;
            if (this._recalc = !1, t < 0 || t > 360 || e < 0 || e > 100 || o < 0 || o > 100 || n < 0 || n > 1) return !1;
            this._color = S(t, e, o, n);
            var _this$_components = this._components,
                s = _this$_components.hue,
                c = _this$_components.opacity,
                a = _this$_components.palette;
            return s.update(t / 360), c.update(n), a.update(e / 100, 1 - o / 100), i || this.applyColor(), r && this._updateOutput(), this._recalc = r, !0;
          }
        }, {
          key: "setColor",
          value: function setColor(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            if (null === t) return this._clearColor(e), !0;

            var _this$_parseLocalColo2 = this._parseLocalColor(t),
                o = _this$_parseLocalColo2.values,
                n = _this$_parseLocalColo2.type;

            if (o) {
              var _t11 = n.toUpperCase(),
                  _i6 = this._root.interaction.options,
                  _r6 = _i6.find(function (e) {
                return e.getAttribute("data-type") === _t11;
              });

              if (_r6 && !_r6.hidden) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                  for (var _iterator4 = _i6[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _t12 = _step4.value;

                    _t12.classList[_t12 === _r6 ? "add" : "remove"]("active");
                  }
                } catch (err) {
                  _didIteratorError4 = true;
                  _iteratorError4 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
                      _iterator4["return"]();
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4;
                    }
                  }
                }
              }

              return this.setColorRepresentation(_t11), this.setHSVA.apply(this, _toConsumableArray(o).concat([e]));
            }

            return !1;
          }
        }, {
          key: "setColorRepresentation",
          value: function setColorRepresentation(t) {
            return t = t.toUpperCase(), !!this._root.interaction.options.find(function (e) {
              return e.getAttribute("data-type").startsWith(t) && !e.click();
            });
          }
        }, {
          key: "getColorRepresentation",
          value: function getColorRepresentation() {
            return this._representation;
          }
        }, {
          key: "getColor",
          value: function getColor() {
            return this._color;
          }
        }, {
          key: "getRoot",
          value: function getRoot() {
            return this._root;
          }
        }, {
          key: "disable",
          value: function disable() {
            return this.hide(), this.options.disabled = !0, this._root.button.classList.add("disabled"), this;
          }
        }, {
          key: "enable",
          value: function enable() {
            return this.options.disabled = !1, this._root.button.classList.remove("disabled"), this;
          }
        }]);

        return R;
      }();

      R.utils = n, R.libs = {
        HSVaColor: S,
        Moveable: P,
        Nanopop: x,
        Selectable: L
      }, R.create = function (t) {
        return new R(t);
      }, R.version = "1.2.7";
      e["default"] = R;
    }])["default"];
  });
});
var Pickr = unwrapExports(pickr_min);
var pickr_min_1 = pickr_min.Pickr;

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "/*! Pickr 1.2.7 MIT | https://github.com/Simonwep/pickr */.pickr{position:relative;overflow:visible;transform:translateY(0)}.pickr *{box-sizing:border-box}.pickr .pcr-button{position:relative;height:2em;width:2em;padding:.5em;cursor:pointer;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;border-radius:.15em;background:url('data:image/svg+xml;utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" stroke=\"%2342445A\" stroke-width=\"5px\" stroke-linecap=\"round\"><path d=\"M45,45L5,5\"></path><path d=\"M45,5L5,45\"></path></svg>') no-repeat 50%;background-size:0;transition:all .3s}.pickr .pcr-button:before{background:url('data:image/svg+xml;utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path fill=\"white\" d=\"M1,0H2V1H1V0ZM0,1H1V2H0V1Z\"/><path fill=\"gray\" d=\"M0,0H1V1H0V0ZM1,1H2V2H1V1Z\"/></svg>');background-size:.5em;z-index:-1;z-index:auto}.pickr .pcr-button:after,.pickr .pcr-button:before{position:absolute;content:\"\";top:0;left:0;width:100%;height:100%;border-radius:.15em}.pickr .pcr-button:after{transition:background .3s;background:currentColor}.pickr .pcr-button.clear{background-size:70%}.pickr .pcr-button.clear:before{opacity:0}.pickr .pcr-button.clear:focus{box-shadow:0 0 0 1px #f1f3f4,0 0 0 3px currentColor}.pickr .pcr-button.disabled{cursor:not-allowed}.pcr-app button,.pcr-app input,.pickr button,.pickr input{outline:none;border:none;-webkit-appearance:none}.pcr-app button:focus,.pcr-app input:focus,.pickr button:focus,.pickr input:focus{box-shadow:0 0 0 1px #f1f3f4,0 0 0 3px currentColor}.pcr-app[data-theme=classic]{position:fixed;display:flex;flex-direction:column;z-index:10000;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;box-shadow:0 .15em 1.5em 0 rgba(0,0,0,.1),0 0 1em 0 rgba(0,0,0,.03);width:28.5em;max-width:95vw;padding:.8em;border-radius:.1em;background:#fff;opacity:0;visibility:hidden;transition:opacity .3s,visibility 0s .3s;left:0;top:0}.pcr-app[data-theme=classic].visible{transition:opacity .3s;visibility:visible;opacity:1}.pcr-app[data-theme=classic] .pcr-swatches{display:flex;flex-wrap:wrap;margin-top:.75em}.pcr-app[data-theme=classic] .pcr-swatches.pcr-last{margin:0}@supports (display:grid){.pcr-app[data-theme=classic] .pcr-swatches{display:grid;align-items:center;grid-template-columns:repeat(auto-fit,1.75em)}}.pcr-app[data-theme=classic] .pcr-swatches>button{font-size:1em;position:relative;width:calc(1.75em - 5px);height:calc(1.75em - 5px);border-radius:.15em;cursor:pointer;margin:2.5px;flex-shrink:0;justify-self:center;transition:all .15s;overflow:hidden;background:transparent;z-index:1}.pcr-app[data-theme=classic] .pcr-swatches>button:before{position:absolute;content:\"\";top:0;left:0;width:100%;height:100%;background:url('data:image/svg+xml;utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path fill=\"white\" d=\"M1,0H2V1H1V0ZM0,1H1V2H0V1Z\"/><path fill=\"gray\" d=\"M0,0H1V1H0V0ZM1,1H2V2H1V1Z\"/></svg>');background-size:6px;border-radius:.15em;z-index:-1}.pcr-app[data-theme=classic] .pcr-swatches>button:after{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background:currentColor;border:1px solid rgba(0,0,0,.05);border-radius:.15em;box-sizing:border-box}.pcr-app[data-theme=classic] .pcr-swatches>button:hover{filter:brightness(1.05)}.pcr-app[data-theme=classic] .pcr-interaction{display:flex;flex-wrap:wrap;align-items:center;margin:0 -.2em}.pcr-app[data-theme=classic] .pcr-interaction>*{margin:0 .2em}.pcr-app[data-theme=classic] .pcr-interaction input{letter-spacing:.07em;font-size:.75em;text-align:center;cursor:pointer;color:#75797e;background:#f1f3f4;border-radius:.15em;transition:all .15s;padding:.45em .5em;margin-top:.75em}.pcr-app[data-theme=classic] .pcr-interaction input:hover{filter:brightness(.975)}.pcr-app[data-theme=classic] .pcr-interaction input:focus{box-shadow:0 0 0 1px #f1f3f4,0 0 0 3px rgba(66,133,244,.75)}.pcr-app[data-theme=classic] .pcr-interaction .pcr-result{color:#75797e;text-align:left;flex:1 1 8em;min-width:8em;transition:all .2s;border-radius:.15em;background:#f1f3f4;cursor:text}.pcr-app[data-theme=classic] .pcr-interaction .pcr-result::selection{background:#4285f4;color:#fff}.pcr-app[data-theme=classic] .pcr-interaction .pcr-type.active{color:#fff;background:#4285f4}.pcr-app[data-theme=classic] .pcr-interaction .pcr-clear,.pcr-app[data-theme=classic] .pcr-interaction .pcr-save{width:auto;color:#fff}.pcr-app[data-theme=classic] .pcr-interaction .pcr-clear:hover,.pcr-app[data-theme=classic] .pcr-interaction .pcr-save:hover{filter:brightness(.925)}.pcr-app[data-theme=classic] .pcr-interaction .pcr-save{background:#4285f4}.pcr-app[data-theme=classic] .pcr-interaction .pcr-clear{background:#f44250}.pcr-app[data-theme=classic] .pcr-interaction .pcr-clear:focus{box-shadow:0 0 0 1px #f1f3f4,0 0 0 3px rgba(244,66,80,.75)}.pcr-app[data-theme=classic] .pcr-selection{display:flex;justify-content:space-between;flex-grow:1}.pcr-app[data-theme=classic] .pcr-selection .pcr-picker{position:absolute;height:18px;width:18px;border:2px solid #fff;border-radius:100%;user-select:none}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview{position:relative;z-index:1;width:2em;display:flex;flex-direction:column;justify-content:space-between;margin-right:.75em}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview:before{position:absolute;content:\"\";top:0;left:0;width:100%;height:100%;background:url('data:image/svg+xml;utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path fill=\"white\" d=\"M1,0H2V1H1V0ZM0,1H1V2H0V1Z\"/><path fill=\"gray\" d=\"M0,0H1V1H0V0ZM1,1H2V2H1V1Z\"/></svg>');background-size:.5em;border-radius:.15em;z-index:-1}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview .pcr-last-color{cursor:pointer;transition:background-color .3s,box-shadow .3s;border-radius:.15em .15em 0 0;z-index:2}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview .pcr-current-color{border-radius:0 0 .15em .15em}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview .pcr-current-color,.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview .pcr-last-color{background:currentColor;width:100%;height:50%}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser,.pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity,.pcr-app[data-theme=classic] .pcr-selection .pcr-color-palette{position:relative;user-select:none;display:flex;flex-direction:column;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser:active,.pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity:active,.pcr-app[data-theme=classic] .pcr-selection .pcr-color-palette:active{cursor:grabbing;cursor:-moz-grabbing;cursor:-webkit-grabbing}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-palette{width:100%;height:8em;z-index:1}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-palette .pcr-palette{flex-grow:1;border-radius:.15em}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-palette .pcr-palette:before{position:absolute;content:\"\";top:0;left:0;width:100%;height:100%;background:url('data:image/svg+xml;utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path fill=\"white\" d=\"M1,0H2V1H1V0ZM0,1H1V2H0V1Z\"/><path fill=\"gray\" d=\"M0,0H1V1H0V0ZM1,1H2V2H1V1Z\"/></svg>');background-size:.5em;border-radius:.15em;z-index:-1}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser,.pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity{margin-left:.75em}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser .pcr-picker,.pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity .pcr-picker{left:50%;transform:translateX(-50%)}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser .pcr-slider,.pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity .pcr-slider{width:8px;flex-grow:1;border-radius:50em}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser .pcr-slider{background:linear-gradient(180deg,red,#ff0,#0f0,#0ff,#00f,#f0f,red)}.pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity .pcr-slider{background:linear-gradient(180deg,transparent,#000),url('data:image/svg+xml;utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path fill=\"white\" d=\"M1,0H2V1H1V0ZM0,1H1V2H0V1Z\"/><path fill=\"gray\" d=\"M0,0H1V1H0V0ZM1,1H2V2H1V1Z\"/></svg>');background-size:100%,50%}";
styleInject(css);

//

var isValidColor = function isValidColor(hexColor) {
  return /^#[0-9A-Fa-f]{6}$/i.test(hexColor);
};

var script = {
  name: "ColorPicker",
  props: {
    value: {
      type: String,
      required: true
    },
    showColorInput: {
      type: Boolean,
      "default": false
    },
    showSaveButton: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      pickr: null
    };
  },
  computed: {
    colorCircleClass: function colorCircleClass() {
      return ["color-circle", {
        "is-invalid": !this.valid
      }];
    },
    colorCircleStyle: function colorCircleStyle() {
      return this.valid ? "background-color:".concat(this.value) : "";
    },
    valid: function valid() {
      return isValidColor(this.value);
    }
  },
  watch: {
    value: {
      handler: function handler(color) {
        var current = this.pickr.getColor().toHEXA().toString();

        if (color !== current && isValidColor(color)) {
          this.setPickrColor(color);
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.pickr = Pickr.create({
      el: this.$refs.colorCircle,
      "default": this.value,
      useAsButton: true,
      components: {
        preview: false,
        opacity: false,
        hue: true,
        interaction: {
          hex: false,
          rgba: false,
          hsla: false,
          hsva: false,
          cmyk: false,
          input: this.showColorInput,
          clear: false,
          save: this.showSaveButton
        }
      }
    });
    this.pickr.on("change", function (newColor) {
      _this.onPickrColorChange(newColor.toHEXA().toString());
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.pickr.destroy();
  },
  methods: {
    onColorTextChange: function onColorTextChange(color) {
      this.setPickrColor(color);
    },
    onPickrColorChange: function onPickrColorChange(color) {
      this.$emit("input", color);
    },
    setPickrColor: function setPickrColor(color) {
      this.pickr.setColor(color);
      this.onPickrColorChange(color);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    "class": _vm.colorCircleClass,
    style: _vm.colorCircleStyle
  }, [_c("div", {
    ref: "colorCircle",
    staticClass: "clickable-area"
  })]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-8bd45f4e_0", {
    source: "@charset \"UTF-8\";\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n.color-circle[data-v-8bd45f4e] {\n  border: 1px solid #ced4da;\n  border-radius: 50%;\n  flex: none;\n  height: 25px;\n  position: relative;\n  width: 25px;\n}\n.color-circle.is-invalid[data-v-8bd45f4e]::after {\n  content: \"×\";\n  color: #ef4853;\n  font-size: 17px;\n  line-height: 23px;\n  pointer-events: none;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  width: 23px;\n}\n.clickable-area[data-v-8bd45f4e] {\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n}\n\n/*# sourceMappingURL=ColorPicker.vue.map */",
    map: {
      "version": 3,
      "sources": ["ColorPicker.vue", "/home/circleci/project/packages/color-picker/ColorPicker.vue"],
      "names": [],
      "mappings": "AAAA,gBAAgB;AAChB,mCAAmC;AACnC;;;;;;;;;;;;;;uBAcuB;AACvB,kCAAkC;AAClC,mCAAmC;AACnC;;;;;;;;;;;;;;uBAcuB;AACvB,kCAAkC;ACyElC;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,YANA;EAOA,kBAAA;EACA,WARA;AD/DA;ACyEA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;ADvEA;AC2EA;EACA,eAAA;EACA,YAAA;EACA,WAAA;ADxEA;;AAEA,0CAA0C",
      "file": "ColorPicker.vue",
      "sourcesContent": ["@charset \"UTF-8\";\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n.color-circle {\n  border: 1px solid #ced4da;\n  border-radius: 50%;\n  flex: none;\n  height: 25px;\n  position: relative;\n  width: 25px;\n}\n.color-circle.is-invalid::after {\n  content: \"×\";\n  color: #ef4853;\n  font-size: 17px;\n  line-height: 23px;\n  pointer-events: none;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  width: 23px;\n}\n\n.clickable-area {\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n}\n\n/*# sourceMappingURL=ColorPicker.vue.map */", "<template>\n  <div :style=\"colorCircleStyle\" :class=\"colorCircleClass\">\n    <div ref=\"colorCircle\" class=\"clickable-area\" />\n  </div>\n</template>\n\n<script>\nimport Pickr from \"@simonwep/pickr\";\nimport \"@simonwep/pickr/dist/themes/classic.min.css\";\n\nconst isValidColor = hexColor => /^#[0-9A-Fa-f]{6}$/i.test(hexColor);\n\nexport default {\n  name: \"ColorPicker\",\n  props: {\n    value: {\n      type: String,\n      required: true\n    },\n    showColorInput: {\n      type: Boolean,\n      default: false\n    },\n    showSaveButton: {\n      type: Boolean,\n      default: false\n    }\n  },\n  data() {\n    return {\n      pickr: null\n    };\n  },\n  computed: {\n    colorCircleClass() {\n      return [\"color-circle\", { \"is-invalid\": !this.valid }];\n    },\n    colorCircleStyle() {\n      return this.valid ? `background-color:${this.value}` : \"\";\n    },\n    valid() {\n      return isValidColor(this.value);\n    }\n  },\n  watch: {\n    value: {\n      handler(color) {\n        const current = this.pickr\n          .getColor()\n          .toHEXA()\n          .toString();\n        if (color !== current && isValidColor(color)) {\n          this.setPickrColor(color);\n        }\n      }\n    }\n  },\n  mounted() {\n    this.pickr = Pickr.create({\n      el: this.$refs.colorCircle,\n      default: this.value,\n      useAsButton: true,\n      components: {\n        preview: false,\n        opacity: false,\n        hue: true,\n        interaction: {\n          hex: false,\n          rgba: false,\n          hsla: false,\n          hsva: false,\n          cmyk: false,\n          input: this.showColorInput,\n          clear: false,\n          save: this.showSaveButton\n        }\n      }\n    });\n    this.pickr.on(\"change\", newColor => {\n      this.onPickrColorChange(newColor.toHEXA().toString());\n    });\n  },\n  beforeDestroy() {\n    this.pickr.destroy();\n  },\n  methods: {\n    onColorTextChange(color) {\n      this.setPickrColor(color);\n    },\n    onPickrColorChange(color) {\n      this.$emit(\"input\", color);\n    },\n    setPickrColor(color) {\n      this.pickr.setColor(color);\n      this.onPickrColorChange(color);\n    }\n  }\n};\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"@reciprocity/bootstrap/scss/colors\";\n@import \"@reciprocity/bootstrap/scss/variables\";\n\n$border-width: 1px;\n$circle-size: 25px;\n\n.color-circle {\n  border: $border-width solid $color-ghost;\n  border-radius: 50%;\n  flex: none;\n  height: $circle-size;\n  position: relative;\n  width: $circle-size;\n\n  &.is-invalid::after {\n    content: \"×\";\n    color: $color-error;\n    font-size: 17px;\n    line-height: $circle-size - 2 * $border-width;\n    pointer-events: none;\n    position: absolute;\n    text-align: center;\n    top: 0;\n    width: $circle-size - 2 * $border-width;\n  }\n}\n\n.clickable-area {\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n}\n</style>\n\n<style lang=\"scss\">\n@import \"@reciprocity/bootstrap/scss/variables\";\n@import \"@reciprocity/bootstrap/scss/custom\";\n\n.pcr-app[data-theme=\"classic\"] {\n  max-width: 235px;\n}\n.pcr-app[data-theme=\"classic\"] {\n  .pcr-interaction {\n    .pcr-result {\n      border: 1px solid $gray-400;\n      color: $gray-700;\n      background: $color-white;\n      border-radius: $border-radius-sm;\n      font-size: $font-size-sm;\n      font-family: $font-family-base;\n      padding: $input-padding-x-sm;\n      &:hover {\n        filter: none;\n      }\n      &:focus {\n        border-color: $input-focus-border-color;\n        box-shadow: 0 0 0 0.2rem rgba($color-app-primary, 0.25);\n      }\n    }\n    .pcr-save {\n      padding: $input-btn-padding-y-sm $input-btn-padding-x-sm;\n      border-radius: $border-radius;\n      background-color: $color-app-primary;\n      border: 1px solid $color-app-primary;\n      font-size: $font-size-sm;\n      transition: none;\n      font-family: $font-family-base;\n      letter-spacing: 0;\n      &:hover {\n        filter: none;\n        background-color: darken($color-app-primary, 7.5%);\n      }\n      &:focus {\n        border-color: $input-focus-border-color;\n        background-color: darken($color-app-primary, 7.5%);\n        box-shadow: 0 0 0 0.2rem rgba($color-app-primary, 0.25);\n      }\n    }\n  }\n}\n</style>\n"]
    },
    media: undefined
  }), inject("data-v-8bd45f4e_1", {
    source: "/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/* stylelint-enable color-no-hex */\n.pcr-app[data-theme=classic] {\n  max-width: 235px;\n}\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-result {\n  border: 1px solid #ced4da;\n  color: #495057;\n  background: #ffffff;\n  border-radius: 0.125rem;\n  font-size: 0.75rem;\n  font-family: \"Lato\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n  padding: 0.5rem;\n}\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-result:hover {\n  filter: none;\n}\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-result:focus {\n  border-color: #a0ccf4;\n  box-shadow: 0 0 0 0.2rem rgba(46, 143, 231, 0.25);\n}\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-save {\n  padding: 0.5rem 1rem;\n  border-radius: 0.125rem;\n  background-color: #2e8fe7;\n  border: 1px solid #2e8fe7;\n  font-size: 0.75rem;\n  transition: none;\n  font-family: \"Lato\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n  letter-spacing: 0;\n}\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-save:hover {\n  filter: none;\n  background-color: #197cd6;\n}\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-save:focus {\n  border-color: #a0ccf4;\n  background-color: #197cd6;\n  box-shadow: 0 0 0 0.2rem rgba(46, 143, 231, 0.25);\n}\n\n/*# sourceMappingURL=ColorPicker.vue.map */",
    map: {
      "version": 3,
      "sources": ["ColorPicker.vue", "/home/circleci/project/packages/color-picker/ColorPicker.vue"],
      "names": [],
      "mappings": "AAAA,mCAAmC;AACnC;;;;;;;;;;;;;;uBAcuB;AACvB,kCAAkC;AAClC,mCAAmC;AACnC;;;;;;;;;;;;;;uBAcuB;AACvB,kCAAkC;AAClC,mCAAmC;AACnC;;;;;;;;;;;;;;uBAcuB;AACvB,kCAAkC;AAClC,mCAAmC;ACmHnC,kCAAA;AA3BA;EACA,gBAAA;ADrFA;ACyFA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uEAAA;EACA,eAAA;ADtFA;ACuFA;EACA,YAAA;ADrFA;ACuFA;EACA,qBAAA;EACA,iDAAA;ADrFA;ACwFA;EACA,oBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uEAAA;EACA,iBAAA;ADtFA;ACuFA;EACA,YAAA;EACA,yBAAA;ADrFA;ACuFA;EACA,qBAAA;EACA,yBAAA;EACA,iDAAA;ADrFA;;AAEA,0CAA0C",
      "file": "ColorPicker.vue",
      "sourcesContent": ["/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/*\n/* This file defines colors for the whole app, they are mapped to Bootstrap\n/* variables in bootstrap_reset.scss file. Try and reuse similar colors to\n/* avoid a christmas tree look, use http://chir.ag/projects/name-that-color\n/* for color names\n/*\n/* Rule when adding a new color is to prefix it with $color- to help with\n/* autocomplete\n/*\n\n/* *******************\n\n      APP COLORS\n\n********************* */\n/* stylelint-enable color-no-hex */\n/* stylelint-disable color-no-hex */\n/* stylelint-enable color-no-hex */\n.pcr-app[data-theme=classic] {\n  max-width: 235px;\n}\n\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-result {\n  border: 1px solid #ced4da;\n  color: #495057;\n  background: #ffffff;\n  border-radius: 0.125rem;\n  font-size: 0.75rem;\n  font-family: \"Lato\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n  padding: 0.5rem;\n}\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-result:hover {\n  filter: none;\n}\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-result:focus {\n  border-color: #a0ccf4;\n  box-shadow: 0 0 0 0.2rem rgba(46, 143, 231, 0.25);\n}\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-save {\n  padding: 0.5rem 1rem;\n  border-radius: 0.125rem;\n  background-color: #2e8fe7;\n  border: 1px solid #2e8fe7;\n  font-size: 0.75rem;\n  transition: none;\n  font-family: \"Lato\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n  letter-spacing: 0;\n}\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-save:hover {\n  filter: none;\n  background-color: #197cd6;\n}\n.pcr-app[data-theme=classic] .pcr-interaction .pcr-save:focus {\n  border-color: #a0ccf4;\n  background-color: #197cd6;\n  box-shadow: 0 0 0 0.2rem rgba(46, 143, 231, 0.25);\n}\n\n/*# sourceMappingURL=ColorPicker.vue.map */", "<template>\n  <div :style=\"colorCircleStyle\" :class=\"colorCircleClass\">\n    <div ref=\"colorCircle\" class=\"clickable-area\" />\n  </div>\n</template>\n\n<script>\nimport Pickr from \"@simonwep/pickr\";\nimport \"@simonwep/pickr/dist/themes/classic.min.css\";\n\nconst isValidColor = hexColor => /^#[0-9A-Fa-f]{6}$/i.test(hexColor);\n\nexport default {\n  name: \"ColorPicker\",\n  props: {\n    value: {\n      type: String,\n      required: true\n    },\n    showColorInput: {\n      type: Boolean,\n      default: false\n    },\n    showSaveButton: {\n      type: Boolean,\n      default: false\n    }\n  },\n  data() {\n    return {\n      pickr: null\n    };\n  },\n  computed: {\n    colorCircleClass() {\n      return [\"color-circle\", { \"is-invalid\": !this.valid }];\n    },\n    colorCircleStyle() {\n      return this.valid ? `background-color:${this.value}` : \"\";\n    },\n    valid() {\n      return isValidColor(this.value);\n    }\n  },\n  watch: {\n    value: {\n      handler(color) {\n        const current = this.pickr\n          .getColor()\n          .toHEXA()\n          .toString();\n        if (color !== current && isValidColor(color)) {\n          this.setPickrColor(color);\n        }\n      }\n    }\n  },\n  mounted() {\n    this.pickr = Pickr.create({\n      el: this.$refs.colorCircle,\n      default: this.value,\n      useAsButton: true,\n      components: {\n        preview: false,\n        opacity: false,\n        hue: true,\n        interaction: {\n          hex: false,\n          rgba: false,\n          hsla: false,\n          hsva: false,\n          cmyk: false,\n          input: this.showColorInput,\n          clear: false,\n          save: this.showSaveButton\n        }\n      }\n    });\n    this.pickr.on(\"change\", newColor => {\n      this.onPickrColorChange(newColor.toHEXA().toString());\n    });\n  },\n  beforeDestroy() {\n    this.pickr.destroy();\n  },\n  methods: {\n    onColorTextChange(color) {\n      this.setPickrColor(color);\n    },\n    onPickrColorChange(color) {\n      this.$emit(\"input\", color);\n    },\n    setPickrColor(color) {\n      this.pickr.setColor(color);\n      this.onPickrColorChange(color);\n    }\n  }\n};\n</script>\n\n<style lang=\"scss\" scoped>\n@import \"@reciprocity/bootstrap/scss/colors\";\n@import \"@reciprocity/bootstrap/scss/variables\";\n\n$border-width: 1px;\n$circle-size: 25px;\n\n.color-circle {\n  border: $border-width solid $color-ghost;\n  border-radius: 50%;\n  flex: none;\n  height: $circle-size;\n  position: relative;\n  width: $circle-size;\n\n  &.is-invalid::after {\n    content: \"×\";\n    color: $color-error;\n    font-size: 17px;\n    line-height: $circle-size - 2 * $border-width;\n    pointer-events: none;\n    position: absolute;\n    text-align: center;\n    top: 0;\n    width: $circle-size - 2 * $border-width;\n  }\n}\n\n.clickable-area {\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n}\n</style>\n\n<style lang=\"scss\">\n@import \"@reciprocity/bootstrap/scss/variables\";\n@import \"@reciprocity/bootstrap/scss/custom\";\n\n.pcr-app[data-theme=\"classic\"] {\n  max-width: 235px;\n}\n.pcr-app[data-theme=\"classic\"] {\n  .pcr-interaction {\n    .pcr-result {\n      border: 1px solid $gray-400;\n      color: $gray-700;\n      background: $color-white;\n      border-radius: $border-radius-sm;\n      font-size: $font-size-sm;\n      font-family: $font-family-base;\n      padding: $input-padding-x-sm;\n      &:hover {\n        filter: none;\n      }\n      &:focus {\n        border-color: $input-focus-border-color;\n        box-shadow: 0 0 0 0.2rem rgba($color-app-primary, 0.25);\n      }\n    }\n    .pcr-save {\n      padding: $input-btn-padding-y-sm $input-btn-padding-x-sm;\n      border-radius: $border-radius;\n      background-color: $color-app-primary;\n      border: 1px solid $color-app-primary;\n      font-size: $font-size-sm;\n      transition: none;\n      font-family: $font-family-base;\n      letter-spacing: 0;\n      &:hover {\n        filter: none;\n        background-color: darken($color-app-primary, 7.5%);\n      }\n      &:focus {\n        border-color: $input-focus-border-color;\n        background-color: darken($color-app-primary, 7.5%);\n        box-shadow: 0 0 0 0.2rem rgba($color-app-primary, 0.25);\n      }\n    }\n  }\n}\n</style>\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = "data-v-8bd45f4e";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

var ColorPicker = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, browser, undefined);

export default ColorPicker;
